export enum AccountingPlatform {
  QUICK_BOOKS_ONLINE = 'QUICK_BOOKS_ONLINE',
  QUICK_BOOKS_ONLINE_SANDBOX = 'QUICK_BOOKS_ONLINE_SANDBOX',
  XERO = 'XERO',
  NET_SUITE = 'NET_SUITE',
}
